module.exports = __webpack_public_path__ + "static/media/mailnews_20.720fffa6.ico";